import { UrlConstants } from "../url.constants";
export class ApiAdvertisingConstants {
    static URL = UrlConstants.API_V2 + "Advertising";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetAdvertisingApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetAdvertisingProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateAdvertisingInvoiceReport";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalAdvertisingApplication";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetAdvertisingRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "GetAApplicationTypes";
}
